import TimelineElement from "../TimelineElement";
import Window from "../window/Window";

function Timeline({ data, functions }) {
  let min =
    Math.min(
      ...data
        .map((d) => d.date)
        .join("-")
        .split("-")
        .filter((d) => d)
        .map((d) => Math.floor(d))
    ) - 1;
  let max = new Date().getFullYear() + 2;

  for (var i = 0; i < data.length; i++) {
    let dates = data[i].date.split("-").map((d) => {
      if (Math.floor(d) == 0) {
        return new Date().getFullYear();
      } else {
        return Math.floor(d);
      }
    });
    data[i].start = ((dates[0] - min) / (max - min)) * 100;
    data[i].width = ((dates[1] - dates[0]) / (max - min)) * 100;
    if (i > 0) data[i].max_width = data[i - 1].width - 1;
    if (data[i].width == 0) data[i].width = (1 / (max - min)) * 100;
  }

  return (
    <Window
      id="Timeline"
      title="Formations"
      default_opened
    >
      <div>
        {data
          .filter((el, i) => (i + 1) % 2 != 0)
          .map((element, i) => (
            <TimelineElement
              key={"el1" + "-" + i}
              data={element}
              timeline={[min, max]}
            />
          ))}
      </div>
      <div id="line" />
      <div>
        {data
          .filter((el, i) => (i + 1) % 2 == 0)
          .map((element, i) => (
            <TimelineElement
              key={"el" + "-" + i}
              data={element}
              timeline={[min, max]}
            />
          ))}
      </div>
    </Window>
  );
}

export default Timeline;
